import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Jamaica: Country = {
    identifier: "Jamaica",
    name: "Jamaica",
    countryCode: "JM",
    group: CountryGroup.CENTRAL_AMERICA,
    isUNMember: true,
    flag: "🇯🇲",
    svgPath: "m 258.06175,410.5424 0.342,0.105 0.354,0.055 0.152,0.003 0.143,0.034 0.323,0.253 0.26,0.138 0.985,0.309 0.328,0.533 0.062,0.167 -0.254,0.098 -0.321,0.035 -0.306,0.005 -0.283,-0.101 -0.123,-0.078 -0.295,-0.038 0.074,-0.072 -0.131,-0.033 -0.164,0.007 -0.121,0.205 -0.134,0.162 -0.258,-0.016 -0.099,-0.138 -0.135,0.062 -0.11,0.102 -0.13,0.382 -0.211,-0.19 -0.229,-0.158 -0.287,-0.066 -0.58,-0.011 -0.274,-0.051 -0.228,-0.323 -0.09,-0.092 -0.229,-0.084 -0.228,-0.371 -0.082,-0.051 -0.619,-0.079 -0.127,-0.203 0.038,-0.184 0.206,-0.225 0.101,-0.064 0.342,0.01 0.327,-0.068 0.144,-0.096 0.15,-0.064 1.184,0.163 0.273,10e-4 z",
}
